import React from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faCheck, faTimes } from '@fortawesome/free-solid-svg-icons';
import stylesInput from '../shared/Input.module.css';
import styles from './InputText.module.css';

interface Props {
  label: string,
  placeholder?: string,
  hint?: string,
  icon?: string,
  type?: string,
  disabled?: boolean,
  state?: string,
  valueInput: string,
  onTextChange: (e: React.ChangeEvent<HTMLInputElement>) => void,
  className?: string,
  required?: boolean,
  name?: string,
  onBlur?: (e: React.ChangeEvent<HTMLInputElement>) => void,
  onClick?: (e: React.MouseEvent<HTMLInputElement>) => void,
  ref?: React.RefObject<HTMLInputElement>,
  maxLength?: number,
  id?: string,
  list?: string

}

export default function InputText({
  label, placeholder, hint, icon,
  type,
  disabled, state,
  valueInput, onTextChange,
  className,
  required,
  name,
  onBlur,
  onClick,
  ref,
  maxLength = 128,
  id,
  list
}: Props) {
  const getContainerClass = () => {
    if (disabled) {
      return `${styles.disabled} ${className}`;
    }
    if (state === 'SUCCESS') {
      return `${styles.success} ${className}`;
    }
    if (state === 'ERROR') {
      return `${styles.container} ${className}`;
    }
    return `${styles.container} ${className}`;
  };

  const getInputClass = () => {
    if (disabled) {
      return `${stylesInput.input} ${styles.inputDisabled}`;
    }
    if (state === 'SUCCESS') {
      return `${stylesInput.input} ${styles.inputSuccess}`;
    }
    if (state === 'ERROR') {
      return `${stylesInput.input} ${styles.inputError}`;
    }
    return stylesInput.input;
  };

  const getHintClass = () => {
    if (disabled) {
      return `${styles.hint} ${styles.hintDisabled}`;
    }
    if (state === 'SUCCESS') {
      return `${styles.hint} ${styles.hintSuccess}`;
    }
    if (state === 'ERROR') {
      return `${styles.hint} ${styles.hintError}`;
    }
    return styles.hint;
  };

  return (
    <div className={getContainerClass()}>
      <p
        className={styles.label}
      >
        {(required) && (<span className={styles.required}> * </span>)}
        {label}
      </p>
      <div className={getInputClass()}>
        <input
          id={id}
          ref={ref}
          type={(type === 'password') ? 'password' : 'text'}
          placeholder={placeholder}
          value={valueInput}
          onChange={onTextChange}
          onClick={onClick}
          name={(name) ? (name) : undefined}
          onBlur={onBlur}
          disabled={disabled}
          maxLength={maxLength}
          list={list}
          data-cy={id || name}
        />
        {(state === 'SUCCESS') && <FontAwesomeIcon className={styles.iconSuccess} icon={faCheck} />}
        {(state === 'ERROR') && <FontAwesomeIcon className={styles.iconError} icon={faTimes} />}
        {(icon)
          && (
            <div className={styles.iconContainer}>
              {icon}
            </div>
          )}
      </div>
      {
        (hint && hint.trim() !== '')
        && (
          <p
            className={getHintClass()}
            data-cy={`${id || name}-${(state === 'ERROR') ? 'error' : 'hint'}`}
          >
            {hint}
          </p>
        )
      }
    </div>
  );
}
